// An Add that can't add yet is never a dead button: it says what is missing
// ("Add 6 more guests (minimum 8)", "Pick a date first") and a press takes the
// guest there. This is that press: scroll to the control that fixes it, focus
// it, and ring the part of the page it sits in for a moment ([data-vt-flash],
// styles.css; a colour, never motion under prefers-reduced-motion). It never
// adds anything. The availability panel's Add (VisitSummary) works the same
// way with its own copy of the ring.

let flashing: { el: HTMLElement; timer: ReturnType<typeof setTimeout> } | null = null;

/** Scroll `focus` (else `region`) into view, focus it, ring `region` (else
 *  `focus`). False when there is nothing to show. */
export function showWhatsMissing(
  region: HTMLElement | null | undefined,
  focus?: HTMLElement | null,
): boolean {
  const ring = region ?? focus ?? null;
  const target = focus ?? region ?? null;
  if (!ring || !target) return false;
  const reduce =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  target.scrollIntoView({ block: "center", inline: "nearest", behavior: reduce ? "auto" : "smooth" });
  focus?.focus({ preventScroll: true });
  if (flashing) {
    clearTimeout(flashing.timer);
    flashing.el.removeAttribute("data-vt-flash");
  }
  // Restart the ring on a second press.
  void ring.offsetWidth;
  ring.setAttribute("data-vt-flash", "");
  const el = ring;
  flashing = {
    el,
    timer: setTimeout(() => {
      el.removeAttribute("data-vt-flash");
      if (flashing?.el === el) flashing = null;
    }, 1600),
  };
  return true;
}
